/**
 * useCalendlyModal — état GLOBAL du modal Calendly (prise de rendez-vous).
 *
 * Le modal est monté UNE fois dans app.vue (CalendlyModal) ; n'importe quel
 * bouton du site (header, footer, /contact…) l'ouvre via openCalendly().
 * Remplace les anciens liens WhatsApp « Nous contacter » (Karim 2026-08-05 :
 * la prise de RDV Calendly est plus pro que WhatsApp).
 */
export const CALENDLY_EMBED_URL =
  "https://calendly.com/donoor/30min?embed_type=Inline&embed_domain=donoor.org&hide_gdpr_banner=1&primary_color=1f9afe";

export function useCalendlyModal() {
  const isOpen = useState<boolean>("calendly-modal-open", () => false);

  function openCalendly() {
    isOpen.value = true;
  }
  function closeCalendly() {
    isOpen.value = false;
  }

  return { isOpen, openCalendly, closeCalendly };
}
